const toGqlStrArray = (arr) => `[${arr.map((e) => `"${e}"`)}]`;

export default toGqlStrArray;
